import {DashboardTypes, PersonalDashboardDto, WorkspaceDashboardDto} from "../types/dashboards";

export const getCanEditDashboard = (
  workspaceCanEditProtectedContent: boolean,
  workspaceCanEditContent: boolean,
  dashboard: Pick<WorkspaceDashboardDto, "type" | "protected"> | Pick<PersonalDashboardDto, "type">
) => {
  if (dashboard.type === DashboardTypes.workspace && dashboard.protected) {
    return workspaceCanEditProtectedContent
  } else {
    return workspaceCanEditContent
  }
}

